import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';
import { PIdNameModel, Profile} from './types';
import { hydrateProfile } from './actions';

type ProfileResponse = Profile & {
    Permissions?: PIdNameModel[];
};

const initialState: Profile = {
    id: 0,
    name: '',
    email: '',
    phoneNumber: '',
    position: '',
    projects: '',
    roles: '',
    workspaceName: '',
    isAdmin: false,
    parts: [],
    permissions: []
};

export const getProfile = createAsyncThunk(
    'profile/get',
    async () => {
        const response = await HttpClient.profileApi.getProfile();
        return response.data
    }
)

const profileSplice = createSlice({
    name: 'profile',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        const applyProfile = (state: Profile, action: { payload: Profile }) => {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.email = action.payload.email;
            state.phoneNumber = action.payload.phoneNumber;
            state.position = action.payload.position;
            state.projects = action.payload.projects;
            state.roles = action.payload.roles;
            state.workspaceName = action.payload.workspaceName;
            state.isAdmin = action.payload.isAdmin;
            state.parts = action.payload.parts;
            const payload = action.payload as ProfileResponse;
            state.permissions = payload.permissions ?? payload.Permissions ?? [];
        };

        builder.addCase(getProfile.fulfilled, applyProfile);
        builder.addCase(hydrateProfile, applyProfile);
    }
})

export default profileSplice.reducer;
